import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Col } from 'react-bootstrap';
import FormBusca from './form_busca';
import LocalService from '../../services/local'
import SecretariaService from '../../services/secretaria';
import Local from './local';

const ListarLocais = () => {

    const [locais, setLocais] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [secretarias, setSecretarias] = useState([]);


    const montaSec = async () => {
        const secs = await SecretariaService.listar()
        setSecretarias(secs.data)
    }

    async function fetchLocais() {
        await montaSec()
        const response = await LocalService.categorias({secretaria: "Secretaria Municipal de Esporte, Lazer, Turismo e Cultura"});
        if (response.data.length >= 1) {
            setLocais(response.data)
            setVazio(false)
        } else {
            setLocais([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchLocais();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setLocais={setLocais}
                    setVazio={setVazio}
                    fetchLocais={fetchLocais}
                    secretarias={secretarias}
                    locais={locais}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <h2>Quadras e Centros Esportivos do Município de Macuco</h2>
                    <Row xs={1}>
                        {locais.map((loc, index) =>
                            <Local
                                loc={loc}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarLocais;